import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import HeroCarousel from "@/components/feature/HeroCarousel";
import SectionHeading from "@/components/base/SectionHeading";
import MovieCard from "@/components/base/MovieCard";
import CategorySidebar from "@/pages/home/components/CategorySidebar";
import IntroSection from "@/pages/home/components/IntroSection";
import { categories } from "@/mocks/categories";
import { getFeaturedMovies, getLatestMovies, getPopularMovies } from "@/utils/movie";
import { useSeo } from "@/hooks/useSeo";

export default function Home() {
  const featured = getFeaturedMovies();
  const latest = getLatestMovies(10);
  const popular = getPopularMovies(10);

  useSeo({
    title: "韩国三级电影大全-最新影视资源免费看",
    description:
      "韩国三级电影提供丰富的影视资源，涵盖最新剧情和经典作品，满足用户对韩国影视内容的多样需求。用户可以浏览详细介绍和分类，轻松查找感兴趣的电影。",
    keywords: "韩国三级电影,韩国电影,三级电影,韩国影视,电影资源,高清电影,剧情介绍",
  });

  return (
    <SiteLayout>
      <div className="mx-auto w-full max-w-7xl px-4 py-6 md:px-6 md:py-8">
        <h1 className="sr-only">韩国三级电影大全 - 最新影视资源免费看</h1>

        <HeroCarousel movies={featured} />

        <div className="mt-5 flex gap-2 overflow-x-auto pb-1 no-scrollbar lg:hidden">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.id}`}
              className="flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-3.5 py-2 text-xs font-medium text-foreground-700 transition-colors duration-200 hover:border-primary-300 hover:text-primary-600"
            >
              <i className={`${cat.icon} text-sm text-primary-500`} aria-hidden="true" />
              {cat.name}
            </Link>
          ))}
        </div>

        <div className="mt-8 flex flex-col gap-6 lg:flex-row lg:items-start">
          <aside className="hidden w-full shrink-0 lg:block lg:w-[264px]">
            <div className="sticky top-20">
              <CategorySidebar />
            </div>
          </aside>

          <div className="min-w-0 flex-1 space-y-12">
            <section>
              <SectionHeading
                title="最新上线"
                subtitle="按上映年份排列的最新收录作品"
                linkTo="/category/latest"
              />
              <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4 md:gap-4 xl:grid-cols-5">
                {latest.map((movie) => (
                  <MovieCard key={movie.id} movie={movie} />
                ))}
              </div>
            </section>

            <section>
              <SectionHeading
                title="热门电影"
                subtitle="近期浏览量最高的作品"
                linkTo="/category/highrating"
              />
              <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4 md:gap-4 xl:grid-cols-5">
                {popular.map((movie) => (
                  <MovieCard key={movie.id} movie={movie} />
                ))}
              </div>
            </section>

            <IntroSection />
          </div>
        </div>
      </div>
    </SiteLayout>
  );
}